// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_component_container__GTKUk","input-container":"checkbox_component_input-container__STzbJ"};